import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectEntitiesByFilters } from '../../../../../shared/store/views/entityView';
import { studyGroupsBySchoolIdFilters } from '../../../../../shared/utils/entitiesFiltersUtils';
import Popup from '../../../../../shared/components/ui/popup/Popup';
import HeaderPopup from '../../../../../shared/components/ui/popup/headerPopup/HeaderPopup';
import ContentsPopup from '../../../../../shared/components/ui/popup/contentPopup/ContentPopup';
import FooterPopup from '../../../../../shared/components/ui/popup/footerPopup.js/FooterPopup';
import StudyGroupListSection from '../../../createStudyGroup/createStudyGroupFlowWizard/Classroom/userStudyGroups/StudyGroupListSection/StudyGroupListSection';
import CannotOpenAppletPopup from './cannotOpenAppletPopup/CannotOpenAppletPopup';
import classes from './SelectStudyGroupPopup.module.css';

const SelectStudyGroupPopup = ({ onClose, onSelect }) => {
  const { texts } = useSelector(state => state.translate);
  const { userDetails } = useSelector(state => state.auth);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const filters = useMemo(() => studyGroupsBySchoolIdFilters(userDetails?.defaultSchool?.id), [userDetails?.defaultSchool?.id]);
  const studyGroups = useSelector(state => selectEntitiesByFilters(state, filters));

  const handleContinue = () => {
    if (!selectedGroup) return;
    onSelect(selectedGroup);
  };

  if (!studyGroups?.length) {
    return <CannotOpenAppletPopup onClose={onClose} />;
  }

  return (
    <Popup close={onClose} title={texts.selectStudyGroup} dropClass={classes.BackdropPopupClass}>
      <HeaderPopup className={classes.HeaderPopup}>
        <p className={classes.Title}>{texts.selectStudyGroup}</p>
      </HeaderPopup>
      <ContentsPopup className={classes.Content} scrollDropClass={classes.ContentScroll}>
        <p className={classes.Description}>{texts.selectStudyGroupForApplet}</p>
        <StudyGroupListSection
          title={texts.studyGroupsToChoose}
          groups={studyGroups}
          selectable
          selectedId={selectedGroup?.id}
          onSelect={setSelectedGroup}
          showDomainInfo
        />
      </ContentsPopup>
      <FooterPopup next={handleContinue} disabled={!selectedGroup} className={classes.Footer} />
    </Popup>
  );
};

export default SelectStudyGroupPopup;